interface IGoal {
  name: string;
  slug: string;
  uid: string;
}

// eslint-disable-next-line import/prefer-default-export
export const getEnrollmentBreadCrumbs = (
  goal: IGoal,
  isOfflineSubscription: boolean,
  type: 'enrolled' | 'enrolledBatches' | 'enrolledCourses'
): { title: string; url: string }[] => {
  if (!goal) return [];

  const plannerPage = {
    title: goal.name,
    url: `/goal/${goal.slug}/${goal.uid}/planner`
  };

  const browsePage = {
    title: isOfflineSubscription ? 'Centre' : 'Plus',
    url: `/goal/${goal.slug}/${goal.uid}/browse`
  };

  const enrollmentPage = {
    title: 'Enrolled',
    url: `/goal/${goal.slug}/${goal.uid}/enrolled`
  };

  const courseEnrollmentPage = {
    title: 'Courses Enrolled',
    url: `/goal/${goal.slug}/${goal.uid}/enrolled/courses`
  };

  const batchEnrollmentPage = {
    title: 'Batches Enrolled',
    url: `/goal/${goal.slug}/${goal.uid}/enrolled/batches`
  };

  switch (type) {
    case 'enrolled':
      return [plannerPage, browsePage, enrollmentPage];
    case 'enrolledBatches':
      return [plannerPage, browsePage, enrollmentPage, batchEnrollmentPage];
    case 'enrolledCourses':
      return [plannerPage, browsePage, enrollmentPage, courseEnrollmentPage];
    default:
      return [];
  }
};
